import { createFilterOptions } from '@mui/material/Autocomplete';
import { TeamModel } from '../types/TeamModel';

// MUI's default Autocomplete filter only searches getOptionLabel(), which for the
// team selectors is the abbreviation. Stringify the name too so "Lakers" finds LAL.
export const teamAutocompleteFilter = createFilterOptions<TeamModel>({
  stringify: (team) => `${team.abbreviation ?? ''} ${team.name ?? ''}`,
});
